<template>
    <v-card
        tile
        class="data-protection"
    >
        <v-card-title>
            <h1>Privacy policy for the use of Trendmanager</h1>
        </v-card-title>
        <v-card-text>
            <h3>Processing of personal data by the operator (Processor TRENDONE GmbH)</h3>

            <p>
                Trendmanager is made available to our clients. This means that certain processing is carried out on behalf of
                the respective customer to enable you to use Trendmanager. In this case, TRENDONE GmbH is the processor and the
                customer is responsible for the processing of your data.
            </p>

            <p>
                Trendmanager is operated by TRENDONE GmbH (Gasstraße 2, 22761 Hamburg, Germany)
                (<a href="https://www.trendone.com/impressum" target="_blank">https://www.trendone.com/impressum</a>). TRENDONE
                GmbH is only the operator of Trendmanager and in this context a processor according to Art. 28 GDPR. The basis
                for processing by TRENDONE GmbH in this regard is a data processing agreement between the controller and
                TRENDONE GmbH. In addition, TRENDONE GmbH processes further data for the provision of these services, in
                particular for the operation of Trendmanager, which may also be personal data. This will be discussed in more
                detail below.
            </p>

            <h3>Evaluation of trends</h3>

            <p>
                Our customers can use this platform to create trend radars. This is done by evaluating trends. This
                evaluation can be carried out via a link and is always anonymous. No personal data is collected from you
                during this public evaluation.
            </p>

            <h3>Personalization and assignment of evaluations</h3>

            <p>
                Optionally, this evaluation can also be personalized. For this purpose, personal data (first name, last
                name, email address) is collected in order to fulfill the purpose of obtaining an evaluation that can be
                assigned to a specific person.
            </p>

            <p>
                This personalized evaluation is optional and is carried out on the legal basis of consent in accordance
                with Art. 6 (1) lit. a) GDPR.
            </p>

            <p>
                Consent to the collection and processing of your personal data for personalized evaluation can be
                refused, in which case participation in the evaluation can be anonymous. Since in this case no
                conclusions can be drawn about a specific natural person, the GDPR does not apply to this process.
            </p>

            <h3>Access to and storage of information in terminal equipment</h3>

            <p>
                By using Trendmanager, information may be accessed (e.g. IP address) or stored (e.g. cookies) in your terminal
                equipment. This access or storage may involve further processing of personal data within the meaning of the
                GDPR. In cases where such access to information or such storage of information is absolutely necessary for the
                technically error-free provision of our services, this is done on the basis of Sect. 25 para. 1 p. 1, para. 2
                no. 2 TTDSG.
            </p>

            <p>
                In cases where such a process serves other purposes (e.g. the needs-based design of our website), this will only
                be carried out on the basis of Sect. 25 para. 1 TTDSG with your consent in accordance with Article 6 para. 1 (a)
                GDPR. The consent can be revoked at any time for the future. The provisions of the GDPR and the German Federal
                Data Protection Act (BDSG) apply to the processing of your personal data.
            </p>

            <h3>Web hosting</h3>

            <p>
                Trendmanager is hosted by an external service provider. The hosting takes place in Germany. Personal data
                collected on Trendmanager is stored on the hoster's servers. This may include IP addresses, contact requests,
                meta and communication data, website accesses and other data. We collect the listed data in order to be able to
                guarantee a smooth connection of the website and a technically error-free provision of our services. The
                processing of this data is absolutely necessary in order to provide you with Trendmanager.
            </p>

            <h3>Server log files</h3>

            <p>
                When you access Trendmanager, it is technically necessary that data is transmitted to our web server via your
                internet browser. The following data is recorded during an ongoing connection for communication between your
                internet browser and our server:
            </p>

            <ul>
                <li>Date and time of the request</li>
                <li>Name of the requested file</li>
                <li>Page from which the file was requested</li>
                <li>Access status</li>
                <li>Web browser and operating system used</li>
                <li>Transmitted data volume</li>
            </ul>

            <p>
                We collect the listed data in order to be able to guarantee a smooth connection setup and a technically
                error-free provision of our service. The processing of this data is absolutely necessary to provide you with
                Trendmanager. The log files are used to evaluate system security and stability as well as for administrative
                purposes.
            </p>

            <p>
                For reasons of technical security, in particular to defend against attempted attacks on our web server, this
                data is stored by us for a short time and deleted after 7 days.
            </p>

            <h3>Cookies</h3>

            <p>
                Trendmanager uses so-called "cookies". Cookies are small text files that are stored either temporarily for the
                duration of a session (session cookies) or permanently (permanent cookies) on your terminal device. Session
                cookies are automatically deleted at the end of your visit. Permanent cookies remain stored on your end device
                until you delete them yourself or until they are automatically deleted by your web browser. Cookies have various
                functions. Many cookies are technically necessary, as certain website functions would not work without them.
                Other cookies are used to evaluate user behaviour or to display advertising.
            </p>

            <p>
                The processing of data through the use of absolutely necessary cookies is based on a legitimate interest in
                accordance with Art. 6 para. 1 (f) GDPR in the technically error-free provision of our services.
            </p>

            <p>
                The processing of personal data through the use of other cookies is based on consent pursuant to Art. 6 para. 1
                (a) GDPR. The consent can be revoked at any time for the future. Insofar as such cookies are used for analysis
                and optimisation purposes, we will inform you separately about this within the scope of this privacy notice and
                obtain consent in accordance with Art. 6 para. 1 lit. a GDPR.
            </p>

            <p>
                You can set your browser in such a way that you
            </p>

            <ul>
                <li>are informed about the setting of cookies,</li>
                <li>allow cookies only in individual cases,</li>
                <li>exclude the acceptance of cookies for certain cases or in general,</li>
                <li>activate the automatic deletion of cookies when closing the browser.</li>
            </ul>

            <p>
                The cookie settings can be managed under the following links for the respective browsers:
            </p>

            <ul>
                <li>
                    <a
                        href="https://support.google.com/chrome/answer/95647?hl=en&hlrm=en&sjid=651634491894821703-EU"
                        target="_blank">
                        Google Chrome
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=cookies-erlauben-und-ablehnen&redirectlocale=de"
                        target="_blank">
                        Mozilla Firefox
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.microsoft.com/en-gb/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d"
                        target="_blank">
                        Edge (Microsoft)
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
                        target="_blank">
                        Safari
                    </a>
                </li>
                <li>
                    <a
                        href="https://help.opera.com/en/latest/web-preferences/#cookies"
                        target="_blank">
                        Opera
                    </a>
                </li>
            </ul>

            <p>
                You can also individually manage cookies of many companies and functions that are used for advertising. Use the
                corresponding user tools for this purpose, available at
                <a href="https://www.aboutads.info/choices/" target="_blank">https://www.aboutads.info/choices/</a>
                or
                <a href="https://www.youronlinechoices.com/uk/your-ad-choices" target="_blank">https://www.youronlinechoices.com/uk/your-ad-choices</a>
                .
            </p>

            <p>
                Most browsers also offer a so-called "do-not-track function". When this function is activated, the respective
                browser tells advertising networks, websites and applications that you do not want to be "tracked" for the
                purpose of behavioural advertising and similar purposes.
            </p>

            <p>
                Information and instructions on how to edit this function can be obtained from the links below, depending on
                your browser provider:
            </p>

            <ul>
                <li>
                    <a
                        href="https://support.google.com/chrome/answer/2790761?co=GENIE.Platform%3DDesktop&hl=en&sjid=651634491894821703-EU"
                        target="_blank">
                        Google Chrome
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.mozilla.org/en-US/kb/how-do-i-turn-do-not-track-feature"
                        target="_blank">
                        Mozilla Firefox
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.microsoft.com/en-us/windows/use-do-not-track-in-internet-explorer-11-ad61fa73-d533-ce96-3f64-2aa3a332e792"
                        target="_blank">
                        Edge (Microsoft)
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.apple.com/en-gb/guide/safari/sfri40732/13.0/mac/10.15"
                        target="_blank">
                        Safari
                    </a>
                </li>
                <li>
                    <a
                        href="https://help.opera.com/en/latest/security-and-privacy/#tracking"
                        target="_blank">
                        Opera
                    </a>
                </li>
            </ul>

            <p>
                In addition, you can prevent the loading of so-called scripts by default. "NoScript" allows JavaScripts, Java
                and other plug-ins to be executed only on trusted domains of your choice. Information and instructions on how to
                edit this function can be obtained from the provider of your browser (e.g. for Mozilla Firefox at:
                <a href="https://addons.mozilla.org/de/firefox/addon/noscript/" target="_blank">https://addons.mozilla.org/de/firefox/addon/noscript/</a>).
            </p>

            <p>
                Please note that if you disable cookies, the functionality of our website may be limited.
            </p>

            <h3>Use of Matomo</h3>

            <p>
                On this website, data is collected and stored using the web analytics software Matomo (www.matomo.org), a
                service provided by InnoCraft Ltd, 150 Willis St, 6011 Wellington, New Zealand, ("Matomo") in accordance with
                Art. 6 para. 1 (a) GDPR on the basis of your consent for the statistical analysis of user behaviour for
                optimisation and marketing purposes.
            </p>

            <p>
                When using Matomo, cookies may be used. Cookies are small text files that are stored locally in the cache of the
                site visitor's internet browser. Among other things, the cookies enable the recognition of the Internet browser.
                Pseudonymised user profiles can be created and evaluated from this data for the same purpose.
            </p>

            <p>
                The data collected using the Matomo technology (including your pseudonymised IP address) is only processed on
                our servers. The data collected is not passed on to third parties, including Matomo.
            </p>

            <p>
                The data is deleted as soon as it is no longer required to achieve the purpose for which it was collected. An
                erasure of data at user and event level linked to cookies, user IDs (e.g. user ID) and advertising IDs (e.g.
                DoubleClick cookies, Android advertising ID, IDFA) takes place at the latest after 24 months.
            </p>

            <p>
                The information generated by the cookie in the pseudonymous user profile is not used to personally identify the
                visitor to this website and is not merged with personal data about the holder of the pseudonym.
            </p>

            <p>
                If you do not agree to the storage and analysis of these data from your visit, you can withdraw your consent to
                the storage and use at any time by clicking on the following link. In this case, a so-called opt-out cookie will
                be stored in your browser, which means that no session data will be collected. Please note that the complete
                erasure of your cookies means that the opt-out cookie will also be deleted and you may have to reactivate it.
            </p>

            <div class="d-inline-block">
                <v-switch
                    :input-value="false"
                    :readonly="true"
                    label="Matomo is inactive"
                />
            </div>

            <h3>Data security</h3>

            <p>
                We take appropriate technical and organizational measures in accordance with Article 32 GDPR, taking into
                account the state of the art, the costs of implementation and the nature, scope, circumstances and purposes of
                the processing, as well as the varying likelihood and severity of the risk to the rights and freedoms of natural
                persons, in order to ensure a level of protection appropriate to the risk. This website uses SSL encryption for
                security reasons and to protect the transmission of confidential content.
            </p>

            <h3>Assertion of your rights as a data subject</h3>

            <p>
                If you wish to exercise your rights as a data subject with regard to the use of the Platform, you can contact us
                using the contact details provided above. Please note that if we are not the controller of the processing as
                described above, we will forward your request to the relevant controller for a response.
            </p>

            <h3>Final provisions</h3>

            <p>
                We reserve the right to adapt or update this privacy notice if necessary in compliance with the applicable data
                protection regulations. In this way, we can adapt it to the current legal requirements and take into account
                changes to our services, e.g. when introducing new services. The current version applies to your visit.
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'meta-en-data-protection'
}
</script>

<style lang="sass"
       scoped>
  p
    text-align: justify
  a
    text-decoration: none
    color: black
  address
    font-style: normal
</style>
